import { Drawer, Row, Col, Descriptions, Image, Tag, Spin, Space } from "antd";
import React from "react";
import dayjs from "dayjs";
import { PictureOutlined, EyeOutlined } from "@ant-design/icons";
import { resolveImageUrl } from "../../../utils/image";
import { border, neutral, typography } from "../../../theme/tokens";
import StatusTag from "../../../components/cms/StatusTag";

export default function ViewGiftExchangeTable({
  isModalOpen,
  handleCancel,
  record,
}) {
  const getStatusTag = (status) => {
    return status === 1 ? (
      <StatusTag tone="success" dot>Đang hoạt động</StatusTag>
    ) : (
      <StatusTag tone="danger" dot>Không hoạt động</StatusTag>
    );
  };

  const getUnlimitedTag = (unlimited) => {
    return unlimited === 0 ? (
      <StatusTag>Không giới hạn</StatusTag>
    ) : (
      <StatusTag>Có giới hạn</StatusTag>
    );
  };

  const getGiftTypeTag = (type) => {
    return type === "PRODUCT" ? (
      <StatusTag>Sản phẩm</StatusTag>
    ) : (
      <StatusTag>Dữ liệu</StatusTag>
    );
  };

  const url = resolveImageUrl(record?.image);

  return (
    <Drawer
      title={
        <Space size="middle">
          <EyeOutlined style={{ color: "#0F2A47", fontSize: 18 }} />
          <span style={{ fontSize: typography.size.lg, fontWeight: 600, color: neutral[900] }}>
            Chi tiết chương trình quà tặng
          </span>
        </Space>
      }
      open={isModalOpen}
      onClose={handleCancel}
      width={720}
      // Chỉ đọc nên không có footer; đóng bằng nút X hoặc bấm ra ngoài.
      destroyOnClose
      styles={{
        // Drawer tự cuộn phần body -> bỏ được cặp maxHeight/overflow phải tính tay
        // như khi còn là Modal.
        body: { padding: 24 },
        header: { borderBottom: border.hairline },
      }}
    >
      {!record ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin />
        </div>
      ) : (
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              {record.image ? (
                <Image
                  src={url}
                  alt="Gift Program"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '300px',
                    objectFit: 'contain',
                  }}
                />
              ):(
                <PictureOutlined style={{ fontSize: '24px', color: neutral[400] }} />
              )}
            </div>
          </Col>

          <Col span={24}>
            <Descriptions bordered size="small" column={{ xs: 1, sm: 2 }}>
              <Descriptions.Item label="Tên quà tặng" span={2}>
                {record.name}
              </Descriptions.Item>

              <Descriptions.Item label="Đơn vị">
                {record.mcoupon_branch?.name}
              </Descriptions.Item>

              <Descriptions.Item label="Loại quà tặng">
                {getGiftTypeTag(record.type)}
              </Descriptions.Item>

              <Descriptions.Item label="Điểm quy đổi">
                {record.point}
              </Descriptions.Item>

              <Descriptions.Item label="Hạn mức">
                {record.stock}
              </Descriptions.Item>

              {record.type === "PRODUCT" && (
                <Descriptions.Item label="Danh sách sản phẩm" span={2}>
                  {record.products?.map((product) => (
                    <Tag key={product.id} style={{ margin: '4px' }}>
                      {product.name}
                    </Tag>
                  ))}
                </Descriptions.Item>
              )}

              {record.type === "DATA" && (
                <>
                  <Descriptions.Item label="Nhà mạng">
                    {record.items?.[0]?.telco}
                  </Descriptions.Item>
                  <Descriptions.Item label="Gói dữ liệu">
                    {record.items?.[0]?.data_pack}
                  </Descriptions.Item>
                </>
              )}

              <Descriptions.Item label="Ngày bắt đầu">
                {record.start_date ? dayjs(record.start_date).format("DD/MM/YYYY HH:mm") : "—"}
              </Descriptions.Item>

              <Descriptions.Item label="Ngày kết thúc">
                {record.end_date ? dayjs(record.end_date).format("DD/MM/YYYY HH:mm") : "—"}
              </Descriptions.Item>

              <Descriptions.Item label="Giới hạn số lần đổi">
                {getUnlimitedTag(record.unlimited)}
              </Descriptions.Item>

              <Descriptions.Item label="Trạng thái">
                {getStatusTag(record.status)}
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
      )}
    </Drawer>
  );
}
